import { render } from "./LoadingComponent.vue?vue&type=template&id=cd65927e"
import script from "./LoadingComponent.vue?vue&type=script&lang=js"
export * from "./LoadingComponent.vue?vue&type=script&lang=js"

import "./LoadingComponent.vue?vue&type=style&index=0&id=cd65927e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__